import styled from "styled-components";
import { apolloSpaceInset4X, apolloSpaceInset3X, apolloSpaceInset2X, apolloSpaceInset1X, apolloSpaceInsetHalfX, apolloFontFamilyEyebrowSmall, apolloFontSizeEyebrowSmall, apolloFontWeightEyebrowSmall, apolloSpaceInline1HalfX, } from "@nexthink/apollo-tokens";
import { StyledMenuItem } from "./MenuItem.style";
import { variant } from "styled-system";
export const StyledGroupName = styled.span.withConfig({ displayName: "StyledGroupName_APC-7281-productShell", componentId: "sc-hv3vj4" })(({ theme, size }) => ({
    whiteSpace: "nowrap",
    color: theme.colors.apolloColorTextSecondary,
    fontFamily: apolloFontFamilyEyebrowSmall,
    fontSize: apolloFontSizeEyebrowSmall,
    fontWeight: apolloFontWeightEyebrowSmall,
    padding: `0 ${apolloSpaceInline1HalfX}`,
    textTransform: "uppercase",
    lineHeight: size === "medium" ? apolloSpaceInset4X : apolloSpaceInset3X,
}), () => variant({
    prop: "variant",
    variants: {
        classic: {
            padding: `0 ${apolloSpaceInset2X}`,
        },
        select: {
            padding: `0 ${apolloSpaceInset1X}`,
            "&[data-focus-visible-added] > span::before": {
                left: `-${apolloSpaceInsetHalfX}`,
                right: `-${apolloSpaceInsetHalfX}`,
            },
        },
    },
}));
export const StyledMenuGroup = styled.div.withConfig({ displayName: "StyledMenuGroup_APC-7281-productShell", componentId: "sc-wm20q1" })(({ theme }) => ({
    background: theme.colors.apolloColorBackgroundMenuItemDefault,
    margin: 0,
}), () => variant({
    prop: "variant",
    variants: {
        classic: {
            "& > li": {
                paddingLeft: apolloSpaceInset3X,
            },
        },
        select: {
            [StyledMenuItem]: {
                paddingLeft: apolloSpaceInset2X,
            },
        },
    },
}));
//# sourceMappingURL=MenuGroup.style.js.map